const styles = theme => ({
  root: {
    width: '50%',
    marginTop: theme.spacing.unit * 4.5,
    '&:nth-child(-n + 2)': {
      marginTop: 0
    }
  },
  detail: {
    color: 'rgba(12,31,44,0.6)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    margin: 0,
    marginBottom: theme.spacing.unit,
    '&:last-child': {
      marginBottom: 0
    }
  },
  name: {
    fontWeight: 'bold',
    marginBottom: theme.spacing.unit * 2
  },
  moreDetails: {
    marginTop: theme.spacing.unit * 3
  }
});

export default styles;
